import { Check } from 'lucide-react';

interface Tag {
  id: string;
  name: string;
}

interface TagSelectorProps {
  tags: Tag[];
  selectedTagIds: string[];
  onChange: (selectedIds: string[]) => void;
  label?: string;
  required?: boolean;
}

export default function TagSelector({ tags, selectedTagIds, onChange, label, required }: TagSelectorProps) {
  const toggleTag = (tagId: string) => {
    if (selectedTagIds.includes(tagId)) {
      // Remove tag
      onChange(selectedTagIds.filter(id => id !== tagId));
    } else {
      // Add tag
      onChange([...selectedTagIds, tagId]);
    }
  };

  return (
    <div>
      {label && (
        <label className="block text-sm font-medium text-glass-text-2 mb-2">
          {label}
          {required && <span className="text-rose-500 dark:text-rose-300 ml-1">*</span>}
        </label>
      )}
      
      <div className="flex flex-wrap gap-2">
        {tags.map((tag) => {
          const isSelected = selectedTagIds.includes(tag.id);
          
          return (
            <button
              key={tag.id}
              type="button"
              onClick={() => toggleTag(tag.id)}
              className={`
                relative px-4 py-2 rounded-full text-sm font-medium transition-all duration-200
                ${isSelected
                  ? 'bg-accent2 text-white shadow-md hover:bg-accent2/90 ring-2 ring-accent2 ring-offset-2 ring-offset-transparent'
                  : 'bg-glass-3 text-glass-text-2 hover:bg-glass-2 border border-glass'
                }
              `}
            >
              <span className="flex items-center gap-2">
                {isSelected && <Check className="w-4 h-4" />}
                {tag.name}
              </span>
            </button>
          );
        })}
      </div>
      
      {selectedTagIds.length > 0 && (
        <div className="mt-2 text-sm text-glass-text-2">
          {selectedTagIds.length} tag{selectedTagIds.length !== 1 ? 's' : ''} selected
        </div>
      )}
    </div>
  );
}

